import {Paper, Space, TextInput} from "@mantine/core";
import { EyeSlash as IconEyeOff, MagnifyingGlass as IconSearch } from "@phosphor-icons/react";
import {DataTable} from "mantine-datatable";
import {useMemo, useState} from "react";
import {Col, Row} from "../../../components/Flex/Flex";
import Label from "../../../components/Label/Label";
import TravelPlanner from "../../../components/TravelPlanner/TravelPlanner.tsx";



const bodyLocation = (row) => {
    return (<div>
        <div>{row.sector.name}</div>
        <div>{row.system.name} <small>({row.system.x},{row.system.y})</small></div>
        <div>{row.planet.name} <small>({row.planet.x},{row.planet.y})</small></div>
        <div>{row.city.name} <small>({row.city.x}, {row.city.y})</small></div>
        <div>Ground: <small>({row.x},{row.y})</small></div>
    </div>)
}
const bodyActions = (row) => {
    return <TravelPlanner system={row.system} space={row.planet} surface={row.city} ground={row} />
}

const bodyPrivate = (row) => {
    return row.private ? <IconEyeOff size={16} title="Private" /> : null;
}

const GLOBAL_FILTER_FIELDS = ['name', 'owner.name', 'sector.name', 'system.name', 'city.name', 'notes'];

const getNestedValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => acc?.[part], obj);
};

export default function ViewList({filteredData, toggleElement, filterElement, locationElement, hasLocation}) {
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const PAGE_SIZE = 50;

    const searchFilteredData = useMemo(() => {
        if (!search) return filteredData;
        const lower = search.toLowerCase();
        return filteredData.filter(row =>
            GLOBAL_FILTER_FIELDS.some(field => {
                const val = getNestedValue(row, field);
                return val && String(val).toLowerCase().includes(lower);
            })
        );
    }, [filteredData, search]);

    const sortedData = useMemo(() => {
        const field = hasLocation ? 'distance' : 'system.name';
        return [...searchFilteredData].sort((a, b) => {
            const aVal = getNestedValue(a, field);
            const bVal = getNestedValue(b, field);
            if (aVal == null) return 1;
            if (bVal == null) return -1;
            if (typeof aVal === 'number') return aVal - bVal;
            return String(aVal).localeCompare(String(bVal));
        });
    }, [searchFilteredData, hasLocation]);

    const paginatedData = useMemo(() => {
        const start = (page - 1) * PAGE_SIZE;
        return sortedData.slice(start, start + PAGE_SIZE);
    }, [sortedData, page]);

    const columns = useMemo(() => {
        const cols = [
            {accessor: 'private', title: '', render: bodyPrivate},
            {accessor: 'name', title: 'Name'},
            {accessor: 'owner.name', title: 'Owner'},
            {accessor: 'city.name', title: 'Location', render: bodyLocation},
            {accessor: 'access', title: 'Access'},
            {accessor: 'shield', title: 'Shield status'},
            {accessor: 'notes', title: 'Notes'},
        ];
        if (hasLocation) {
            cols.push({accessor: 'distance', title: 'Distance', sortable: true});
        }
        cols.push({accessor: 'actions', title: 'Actions', render: bodyActions});
        return cols;
    }, [hasLocation]);

    return (
        <div>
            <Paper className="mb-2">
                <Row align="end">
                    <Col>
                        {toggleElement}
                    </Col>
                    <Col>
                        {filterElement}
                    </Col>
                    <Col grow={1} />
                    <Col>
                        {locationElement}
                    </Col>
                    <Col grow={1}/>
                    <Col>
                        <TextInput
                            leftSection={<IconSearch size={16}/>}
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                            placeholder="Search"
                        />
                    </Col>
                </Row>
            </Paper>
            <Space h="md" />
            <Paper>
                <DataTable
                    records={paginatedData}
                    idAccessor="id"
                    columns={columns}
                    totalRecords={sortedData.length}
                    recordsPerPage={PAGE_SIZE}
                    page={page}
                    onPageChange={setPage}
                    noRecordsText="No taverns found"
                />
            </Paper>
        </div>
    )
}
